var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.options.show_as_iframe === true)?_c('iframe',_vm._b({attrs:{"src":_vm.value}},'iframe',_vm.options.frame_options,false)):_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.link))])])
}
var staticRenderFns = []

export { render, staticRenderFns }